import { render, staticRenderFns } from "./RoomTable.vue?vue&type=template&id=4fc932af&scoped=true&"
import script from "./RoomTable.vue?vue&type=script&lang=js&"
export * from "./RoomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc932af",
  null
  
)

export default component.exports